import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';

//install redux store
import { store } from './config/store'
import { Provider } from 'react-redux'

//import package for routing
import {
  BrowserRouter,
  createBrowserRouter,
  RouterProvider,
} from "react-router-dom";

//Components import
import Work from './learning/Work';
import Template from './components/layouts/Template';
import Home from './components/users/Home';
import Register from './components/auth/Register';
import LandingPage from './pages/LandingPage';

//create our routes before insert in the app
const router = createBrowserRouter([
  //Main page with App component wich have login component
  {
    path: "/",
    element: <App />,

  },
  {
    path: "/landing",
    element: <LandingPage/>,
  },
  {
    path: "/register",
    element: <Register />,

  },
  {
    path: "/dashboard",
    element: <Template />,
    children: [
      {
        path: "/dashboard/home",
        element: <p>At home</p>,
      },

    ],

  },
]);

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    {/* wrap all with the provider for redux passing store */}
    <Provider store={store}>

      <BrowserRouter>
        <App />
      </BrowserRouter>
      {/* Insert the routes in the app */}
      {/* <RouterProvider router={router} /> */}
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
